import React from 'react';
import { Avatar, Box, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core';
import getInitials from 'src/utils/getInitials';
import { ArrowDownLeft, ArrowUpRight } from 'react-feather';
import { formatDateLabel } from '../../utils';
import moment from 'moment';
import { CallButton } from '../Conversation/CallButton';
import { useTranslation } from 'react-i18next';

export const CallItem = ({ call }: { call: any }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const caller = call.user?.name || t('Chat.UnknownUser');
    const callee = call.contact?.name || call.name || call.to || t('Chat.Contact');
    const image = call.contact?.image;
    const direction = call.Direction;
    const status = call.DialCallStatus;
    const createdAt = call.createdAt;

    const isCompleted = status === 'completed';

    const isInbound = direction === 'inbound';
    const duration = Number(call.DialCallDuration || 0);
    const durationFormat = duration >= 3600 ? 'HH:mm:ss' : 'mm:ss';
    const storeArea = call.store?.areas?.find(
        (area: { name?: string }) => area.name === call.area
    );

    return (
        <Box
            key={call._id}
            style={{
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 5,
                padding: '8px 12px',
                display: 'flex',
            }}
        >
            <Box
                style={{
                    display: 'flex',
                    gap: 10,
                    flexGrow: 1,
                    minWidth: 0,
                }}
            >
                <Avatar
                    src={image}
                    style={{
                        width: 64,
                        height: 64,
                    }}
                >
                    {getInitials(callee)}
                </Avatar>
                <Box
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        gap: 1,
                        minWidth: 0,
                    }}
                >
                    <Typography variant="h4" color="textPrimary" noWrap>
                        {callee}
                    </Typography>
                    <Box
                        style={{
                            display: 'flex',
                            gap: 5,
                            alignItems: 'center',
                        }}
                    >
                        {isInbound ? (
                            <ArrowUpRight
                                style={{
                                    color: isCompleted
                                        ? theme.palette.success.main
                                        : theme.palette.error.main,
                                }}
                            />
                        ) : (
                            <ArrowDownLeft
                                style={{
                                    color: isCompleted
                                        ? theme.palette.success.main
                                        : theme.palette.error.main,
                                }}
                            />
                        )}
                        <Typography variant="caption" color="textSecondary">
                            {formatDateLabel(new Date(createdAt), t)}
                            ,{' '}
                            {moment(createdAt).format('HH:mm a')}
                        </Typography>
                    </Box>
                    <Typography variant="caption" color="textSecondary">
                        {t('Chat.PerformedBy')} {caller}
                    </Typography>
                    <Typography variant="caption" color="textSecondary">
                        {call.store?.name || t('Chat.NoAgency')} ·{' '}
                        {moment.utc(duration * 1000).format(durationFormat)}
                    </Typography>
                </Box>
            </Box>

            <Box style={{ display: 'flex', alignItems: 'center' }}>
                <CallButton
                    conversationId={call.warboxConversation}
                    contactId={call.contact?._id}
                    name={callee}
                    phone={call.contact?.phone || call.to}
                    storeId={call.store?._id}
                    area={call.area}
                    callerPhone={storeArea?.phone || storeArea?.phoneCallerId}
                    storeCountryCode={
                        call.contact?.countryCode || call.store?.countryCode
                    }
                    tokenOnDemand
                />
            </Box>
        </Box>
    );
};
